var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 84,
    viewBox: "0 0 103 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M96.8893 0.312455L4.59153 13.648C3.50438 13.7949 2.49638 14.2974 1.72468 15.0771C0.952978 15.8569 0.460946 16.87 0.325286 17.9586C0.170568 19.0511 0.381571 20.1641 0.925415 21.1241C1.46926 22.0842 2.3154 22.8374 3.33198 23.2664L37.7743 38.0221C38.2806 38.2553 38.6995 38.6436 38.9704 39.1308C39.2413 39.6179 39.35 40.1787 39.281 40.7318L34.623 77.964C34.4942 79.0556 34.7215 80.1596 35.2711 81.1116C35.8207 82.0635 36.6632 82.8124 37.673 83.2467C38.3868 83.5516 39.1618 83.6862 39.9367 83.6397C40.7115 83.5931 41.4649 83.3669 42.1371 82.9788C42.704 82.6606 43.2035 82.235 43.6075 81.7257L101.529 8.44778C102.158 7.66098 102.536 6.70332 102.615 5.69889C102.694 4.69446 102.469 3.68953 101.97 2.81432C101.471 1.93911 100.72 1.23395 99.8159 0.790186C98.9114 0.346422 97.8944 0.184515 96.8968 0.325445L96.8893 0.312455ZM5.31439 18.6L90.9062 6.24941L41.6727 34.6744C41.1075 34.1458 40.4524 33.7224 39.7384 33.4241L5.31439 18.6ZM39.6046 78.5924L44.2701 41.3732C44.3955 40.585 44.3623 39.7798 44.1727 39.0045L93.4495 10.5545L39.6046 78.5924Z",
    fill: "#173325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSended);
export default __webpack_public_path__ + "static/media/message_sended.e15c45a33e4f676c2bd46bbcf3910b70.svg";
export { ForwardRef as ReactComponent };